import Jt1078CmdModal from './jt1078-cmd-modal.vue'
export default Jt1078CmdModal
